import { RootState } from "../rootReducer"

export const selectSlots = (state: RootState) => state.slots.slots.data ?? []
export const selectCreateSlotState = (state: RootState) => state.slots.createSlot
export const selectUpdateSlotState = (state: RootState) => state.slots.updateSlot
